// Program promo-copy keys -> ad descriptor fields.
const FIELD_BY_COPY_KEY = { ad_headline: 'headline', ad_body: 'body', ad_cta: 'ctaLabel' };

/**
 * `ad` with the program's promo copy applied, or `ad` itself (by identity) when it does not
 * carry `programCopy` or the copy names nothing usable. Missing keys keep the registry copy.
 */
export const applyProgramCopy = (ad, copy) => {
  if (!ad?.programCopy || !copy) return ad;

  const override = {};
  for (const [copyKey, field] of Object.entries(FIELD_BY_COPY_KEY)) {
    const value = copy[copyKey];
    if (typeof value === 'string' && value && value !== ad[field]) override[field] = value;
  }
  return Object.keys(override).length ? { ...ad, ...override } : ad;
};
